import './statusMessage.css';
import React, { useContext, useEffect } from 'react';
import RoomProvider from 'components/Provider/RoomProvider';
import { stylizeKeyword } from 'others/keywords/keywordstyles';
import TypewriterEffect from 'animations/TypewriterEffect';

const typewriterRef = React.createRef();

export function setMessage(room, localMsg = null) {
    var msg = localMsg ? localMsg : room.statusMsg;

    const finalText = stylizeKeyword(msg, room.players, room.localPlayer);
    typewriterRef.current?.animText(finalText);
}

function StatusMessage({ children }) {
    const { room } = useContext(RoomProvider);
    
    useEffect(()=>{
        setMessage(room);
    }, [room.statusMsg]);

    return (
        <div id='smsg_container'>
            <TypewriterEffect 
                ref={typewriterRef} 
                textProps={{ id: 'smsg_text' }}
            />
            {
                children &&
                    <div id='smsg_children'>
                        { children }
                    </div>
            }
        </div>
    );
}

export default StatusMessage;